<template>
    <div>
        <vl-alerts></vl-alerts>
        <vl-modal name="vlDefaultModal"></vl-modal>
        <vl-sliding-panels></vl-sliding-panels>
    </div>
</template>

<script>
    export default {
        
    }
</script>
